import { render, staticRenderFns } from "./PerformanceMoreModal.vue?vue&type=template&id=58f746ea"
import script from "./PerformanceMoreModal.vue?vue&type=script&lang=js"
export * from "./PerformanceMoreModal.vue?vue&type=script&lang=js"
import style0 from "./PerformanceMoreModal.vue?vue&type=style&index=0&id=58f746ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports